export default __webpack_public_path__ + "static/media/user.83b54905.svg";